import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { InformationChip } from '@europrocurement/flexy-components';
import { useStatusStyle } from '@europrocurement/l2d-modules/hooks';
import { StatusStyleType } from '@europrocurement/l2d-modules/hooks/useStatusStyle';
import { DOSSIER_STATUS_AWAITING, DOSSIER_STATUS_TO_CHECK } from '../../../constants/status';

export type DossierStatusProps = {
    label: string;
    statutId: number;
    handleStyleStatus?: (statutId?: number | null | undefined) => StatusStyleType;
    source?: 'FRONT' | 'BACK';
};

const DossierStatus: React.FunctionComponent<DossierStatusProps> = function ({
    label,
    statutId,
    handleStyleStatus,
    source = 'FRONT',
}) {
    const { getDossierStatusStyle, STATUS_STYLE_FORMALIST } = useStatusStyle();

    const baseStyle =
        handleStyleStatus && typeof handleStyleStatus !== 'undefined'
            ? handleStyleStatus(statutId)
            : getDossierStatusStyle(statutId);

    const isFrontToCheck = source === 'FRONT' && statutId === DOSSIER_STATUS_TO_CHECK;
    const { iconProp, sxStatus } = isFrontToCheck
        ? { ...baseStyle, sxStatus: STATUS_STYLE_FORMALIST.sxStatus }
        : baseStyle;

    // Update specific label based on source
    const resolvedLabel = useMemo(() => {
        if (source === 'FRONT') {
            if (statutId === DOSSIER_STATUS_TO_CHECK) {
                return 'En cours de traitement';
            }
            if (statutId === DOSSIER_STATUS_AWAITING) {
                return 'En attente';
            }
        }

        return label;
    }, [label, statutId, source]);

    return (
        <InformationChip
            icon={iconProp}
            color={(sxStatus as { color?: string })?.color ?? undefined}
            sx={{ ...sxStatus, display: 'flex', alignItems: 'center' }}
            sxIcon={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            label={<Typography variant="l2dbodys">{resolvedLabel}</Typography>}
        />
    );
};

export default DossierStatus;
